var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceNice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 108,
    viewBox: "0 0 160 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.76681 57.4665C6.40166 53.9074 12.2335 53.9688 15.7926 57.6036C37.8101 80.0895 65.5121 90.9705 92.8177 89.1501C97.8936 88.8117 102.283 92.6522 102.621 97.7281C102.96 102.804 99.1191 107.193 94.0432 107.532C60.8319 109.746 28.0171 96.4199 2.6297 70.4923C-0.929427 66.8575 -0.868039 61.0256 2.76681 57.4665Z",
    fill: "#3D0E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1887 18.1551C65.1887 28.2412 57.1198 36.3101 47.0336 36.3101C36.9475 36.3101 28.8786 28.2412 28.8786 18.1551C28.8786 8.06891 36.9475 0 47.0336 0C57.1198 0 65.1887 8.06891 65.1887 18.1551Z",
    fill: "#3D0E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160 18.1551C160 28.2412 151.931 36.3101 141.845 36.3101C131.759 36.3101 123.69 28.2412 123.69 18.1551C123.69 8.06891 131.254 0 141.341 0C151.427 0 160 8.06891 160 18.1551Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceNice);
export default __webpack_public_path__ + "static/media/face_nice.11a0e9ea697cc5aa06bc9c7fb8acb8fe.svg";
export { ForwardRef as ReactComponent };